import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { MaxBrainConfirmDialogComponent } from 'app/projects/shared/src/lib/components/dialogs/confirm/confirm.component';
import { Observable, Observer, of } from 'rxjs';

export interface IComponentCanDiscardChanges {
    isDataChanged: boolean;
    discardChangesDialogRef: MatDialogRef<MaxBrainConfirmDialogComponent>;
}

export class DiscardChangesGuard<T extends IComponentCanDiscardChanges> implements CanDeactivate<T> {
    constructor(protected _matDialog: MatDialog, private saveChangesSuccessCallback?: () => void, private discardChangesSuccessCallback?: () => void) {}

    canDeactivate(component: T, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (!component.isDataChanged) {
            return of(true);
        }

        component.discardChangesDialogRef = this._matDialog.open(MaxBrainConfirmDialogComponent, {
            width: '600px',
        });

        component.discardChangesDialogRef.componentInstance.confirmTitle = 'GENERAL.LABEL.UNSAVED_CHANGES';
        component.discardChangesDialogRef.componentInstance.confirmMessage = 'GENERAL.MESSAGE.UNSAVED_CHANGES';
        component.discardChangesDialogRef.componentInstance.actionButtonText = 'GENERAL.BUTTON.SAVE';
        component.discardChangesDialogRef.componentInstance.hideAdditionalActionButton = false;

        return new Observable((observer: Observer<boolean>) => {
            component.discardChangesDialogRef.afterClosed().subscribe(
                (payload) => {
                    if (typeof payload === 'boolean') {
                        if (payload && this.saveChangesSuccessCallback) {
                            this.saveChangesSuccessCallback();
                        }
                        observer.next(payload);
                    } else if (typeof payload === 'object' && payload.info === 'additionalActionButtonClicked') {
                        if (payload.result && this.discardChangesSuccessCallback) {
                            this.discardChangesSuccessCallback();
                        }
                        observer.next(payload.result);
                    }

                    observer.complete();
                    component.discardChangesDialogRef = null;
                },
                (error) => {
                    observer.next(false);
                    observer.complete();
                    component.discardChangesDialogRef = null;
                }
            );
        });
    }
}
